module.exports = __webpack_public_path__ + "img/agregado.5806b1f4.png";